import { STATUS_VARIANT_HIGHLIGHT, StatusType } from '@/components/StatusWrapper/const';
import { REQUEST_STATUS_DB } from '@/types/vendorVaultTypes';

export const REQUEST_STATUS_MAP: StatusType = {
  [REQUEST_STATUS_DB.SENT]: { variant: STATUS_VARIANT_HIGHLIGHT.YELLOW },
  [REQUEST_STATUS_DB.PENDING_VERIFICATION]: { variant: STATUS_VARIANT_HIGHLIGHT.YELLOW },
  [REQUEST_STATUS_DB.COMPLETED]: { variant: STATUS_VARIANT_HIGHLIGHT.GREEN },
  [REQUEST_STATUS_DB.EXPIRED]: { variant: STATUS_VARIANT_HIGHLIGHT.PURPLE },
  [REQUEST_STATUS_DB.REVOKED]: { variant: STATUS_VARIANT_HIGHLIGHT.RED },
  [REQUEST_STATUS_DB.CLOSED]: { variant: STATUS_VARIANT_HIGHLIGHT.DARK_BLUE },
};

export const REQUEST_VIA_LABEL = {
  email: 'Email',
  sms: 'Text message',
  // TODO: 29.5.1 not using those methods for now
  // whatsapp: 'WhatsApp',
  // telegram: 'Telegram',
  copy: 'Copy link',
};

export const REQUEST_EXPIRY_OPTIONS = [
  { value: '24h', label: '24 hours' },
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
];
export const STAMP_LABEL = { verified: 'Verified', received: 'Received', revoked: 'Revoked', closed: 'Closed' };
export const WIDE_TEMPLATE_KEYS = [
  'recipient_address',
  'bank_address',
  'bank_city_country',
  'intermediary_bank',
  'purpose',
  'supporting_document',
];
